import {
  expandLegislationPath,
  $legislationGroup,
  requestAct,
  requestActVersions
} from 'services/LegislationService'
import connect from 'libraries/front-end-core/decorators/connect'
import { isValidResponse } from 'libraries/front-end-core/helpers/dataflow'
import ConnectedWrapper from 'pages/legislation/ConnectedWrapper'
import { map, filter } from 'rxjs/operators'

export const propsToStream = ({ act, scrollMain, editingId }) => ({
  group: $legislationGroup(act.split(':')[0], null, editingId),
  path: expandLegislationPath(act),
  actSections: requestAct({ act }),
  publishedId: requestAct({ act }).pipe(
    filter(isValidResponse),
    map(({ versionId }) => versionId || false)
  ),
  versions: requestActVersions(act)
})

export default connect(propsToStream)(ConnectedWrapper)
